import { HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
var NextSDRDateTypes;
(function (NextSDRDateTypes) {
  NextSDRDateTypes["ZonedDateTime"] = "ZonedDateTime";
  NextSDRDateTypes["LocalDateTime"] = "LocalDateTime";
  NextSDRDateTypes["LocalDate"] = "LocalDate";
})(NextSDRDateTypes || (NextSDRDateTypes = {}));
class ForeignKey {
  id;
  targetEntity;
  url;
}
class BatchOperation {
  operation;
  id;
  entityPath;
  entityBody;
  additionalData;
  returnProjection;
  refreshSavedEntity;
}
var BatchOperationTypes;
(function (BatchOperationTypes) {
  BatchOperationTypes["INSERT"] = "INSERT";
  BatchOperationTypes["UPDATE"] = "UPDATE";
  BatchOperationTypes["DELETE"] = "DELETE";
})(BatchOperationTypes || (BatchOperationTypes = {}));
class FilterDefinition {
  _field;
  _filterMatchMode;
  _value;
  constructor(field, filterMatchMode, value) {
    this._field = field;
    this._filterMatchMode = filterMatchMode;
    this._value = value;
  }
  get field() {
    return this._field;
  }
  set field(value) {
    this._field = value;
  }
  get filterMatchMode() {
    return this._filterMatchMode;
  }
  set filterMatchMode(value) {
    this._filterMatchMode = value;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
class SortDefinition {
  _field;
  _sortMode;
  constructor(field, sortMode) {
    this._field = field;
    this._sortMode = sortMode;
  }
  get field() {
    return this._field;
  }
  set field(value) {
    this._field = value;
  }
  get orderMode() {
    return this._sortMode;
  }
  set orderMode(value) {
    this._sortMode = value;
  }
}
class AdditionalDataDefinition {
  _name;
  _value;
  constructor(name, value) {
    this._name = name;
    this._value = value;
  }
  get name() {
    return this._name;
  }
  set name(name) {
    this._name = name;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
class FilterJsonDefinition {
  _jsonString = "";
  _isJsonArray;
  constructor(isJsonArray = false) {
    this._isJsonArray = isJsonArray;
  }
  add(key, value) {
    this._jsonString += `"${String(key)}": ${value},`;
  }
  buildJsonString() {
    this._jsonString = this._jsonString.substring(0, this._jsonString.length - 1);
    if (this._isJsonArray) {
      this._jsonString = "[{" + this._jsonString + "}]";
    } else {
      this._jsonString = "{" + this._jsonString + "}";
    }
    return this._jsonString;
  }
}
const FILTER_TYPES = {
  string: {
    startsWith: "startsWith",
    startsWithIgnoreCase: "startsWithIgnoreCase",
    contains: "contains",
    containsIgnoreCase: "containsIgnoreCase",
    equals: "equals",
    notEquals: "notEquals",
    equalsIgnoreCase: "equalsIgnoreCase"
  },
  not_string: {
    equals: ""
  }
};
const SORT_MODES = {
  asc: "asc",
  desc: "desc"
};
class FiltersAndSorts {
  _filters = new Array();
  _sorts = new Array();
  _additionalDatas = new Array();
  _rows;
  _first;
  constructor() {}
  get filters() {
    return this._filters;
  }
  set filters(value) {
    this._filters = value;
  }
  get sorts() {
    return this._sorts;
  }
  set sorts(value) {
    this._sorts = value;
  }
  get additionalDatas() {
    return this._additionalDatas;
  }
  set additionalDatas(value) {
    this._additionalDatas = value;
  }
  get rows() {
    return this._rows;
  }
  set rows(value) {
    this._rows = value;
  }
  get first() {
    return this._first;
  }
  set first(value) {
    this._first = value;
  }
  addFilter(filterDefinition) {
    this._filters.push(filterDefinition);
  }
  addSort(sortDefinition) {
    this._sorts.push(sortDefinition);
  }
  addAdditionalData(additionalDataDefinition) {
    this._additionalDatas.push(additionalDataDefinition);
  }
  /**
   * Funzione che rimuove un filtro dato in input il valore del campo
   * @param field
   */
  removeFilter(field) {
    const index = this._filters.findIndex(filter => filter.field === field);
    if (index !== -1) {
      this._filters.splice(index, 1);
    }
  }
}
class UtilityFunctions {
  /**
   * Crea un oggetto in cui le proprietà sono state aggiustate per come se le aspetta il server, per poter essere usato in un Http Post o Patch
   * sostituisce la funzione fixFkFieldsForUpdate()
   * @param origObj oggetto origine
   * @param datepipe
   */
  static cleanObjForHttpCall(origObj, datepipe) {
    if (typeof origObj !== "object") {
      return origObj;
    }
    let newObj = {};
    let hasProp = false;
    for (const prop in origObj) {
      if (prop) {
        hasProp = true;
        if (datepipe && origObj[prop] instanceof Date) {
          const entity = origObj;
          if (entity["nextSdrDateInformation"] && entity["nextSdrDateInformation"][prop] && entity["nextSdrDateInformation"][prop] === NextSDRDateTypes.ZonedDateTime) {
            newObj[prop] = datepipe.transform(origObj[prop], "yyyy-MM-dd'T'HH:mm:ss.SSSSSSZZZZZ");
          } else if (entity["nextSdrDateInformation"] && entity["nextSdrDateInformation"][prop] && entity["nextSdrDateInformation"][prop] === NextSDRDateTypes.LocalDateTime) {
            newObj[prop] = datepipe.transform(origObj[prop], "yyyy-MM-dd'T'HH:mm:ss.SSSSSS");
          } else if (entity["nextSdrDateInformation"] && entity["nextSdrDateInformation"][prop] && entity["nextSdrDateInformation"][prop] === NextSDRDateTypes.LocalDate) {
            newObj[prop] = datepipe.transform(origObj[prop], "yyyy-MM-dd");
            // tslint:disable-next-line:max-line-length
          } else {
            // questo è il default, nel caso non trovi l'oggetto nextSdrDateInformation nell'entity, per ora lo tratto come un LocalDateTime, andrà poi sostituito in ZonedDateTime quando cambieremo tutto le notre date in ZonedDateTime
            // newObj[prop] = datepipe.transform(origObj[prop], "yyyy-MM-dd'T'HH:mm:ss.SSSSSS");
            newObj[prop] = datepipe.transform(origObj[prop], "yyyy-MM-dd'T'HH:mm:ss.SSSSSSZZZZZ");
          }
        } else if (typeof origObj[prop] === "object") {
          if (origObj[prop] instanceof Array) {
            const origArray = origObj[prop];
            const newArray = [];
            origArray.forEach(element => {
              newArray.push(this.cleanObjForHttpCall(element, datepipe));
            });
            newObj[prop] = newArray;
          } else {
            newObj[prop] = this.cleanObjForHttpCall(origObj[prop], datepipe);
          }
        } else {
          newObj[prop] = origObj[prop];
        }
      }
    }
    if (!hasProp) {
      newObj = null;
    }
    return newObj;
  }
  static cleanArrayForHttpCall(origArray, datepipe) {
    const newArray = [];
    origArray.forEach(element => {
      newArray.push(this.cleanObjForHttpCall(element, datepipe));
    });
    return newArray;
  }
  static fixDateFields(obj) {
    if (typeof obj !== "object") {
      return obj;
    }
    // const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
    const zonedDateTimeFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)*(\+|\-)\d{2}:\d{2}(\[.*\/.*\])*$/;
    const localDateTimeFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)*$/;
    const localDateFormat = /^\d{4}-\d{2}-\d{2}$/;
    // if (entity.nextSdrDateInformation) {
    //     entity.nextSdrDateInformation = {};
    // }
    for (const prop in obj) {
      if (typeof obj[prop] === "string" && prop !== "version") {
        const match = zonedDateTimeFormat.exec(obj[prop]);
        if (match !== null) {
          // è una ZonedDateTime
          const zone = match[3];
          let dateString = match[0];
          if (zone) {
            dateString = dateString.replace(zone, "");
          }
          const entity = obj;
          if (!entity["nextSdrDateInformation"]) {
            entity["nextSdrDateInformation"] = {};
          }
          obj[prop] = new Date(dateString);
          // entity["nextSdrDateInformation"][prop] = NextSDRDateTypes.ZonedDateTime;
          // entity.nextSdrDateInformation[prop] = NextSDRDateTypes.ZonedDateTime;
          entity.nextSdrDateInformation[prop] = NextSDRDateTypes.ZonedDateTime;
        } else if (localDateTimeFormat.test(obj[prop])) {
          // è una LocalDateTime
          obj[prop] = new Date(obj[prop]);
          const entity = obj;
          if (!entity["nextSdrDateInformation"]) {
            entity["nextSdrDateInformation"] = {};
          }
          // entity["nextSdrDateInformation"][prop] = NextSDRDateTypes.LocalDateTime;
          // entity.nextSdrDateInformation.[prop] = NextSDRDateTypes.LocalDateTime;
          entity.nextSdrDateInformation[prop] = NextSDRDateTypes.LocalDateTime;
        } else if (localDateFormat.test(obj[prop])) {
          // è una LocalDate
          obj[prop] = new Date(obj[prop]);
          const entity = obj;
          if (!entity["nextSdrDateInformation"]) {
            entity["nextSdrDateInformation"] = {};
          }
          // entity["nextSdrDateInformation"][prop] = NextSDRDateTypes.LocalDate;
          // entity.nextSdrDateInformation.[prop] = NextSDRDateTypes.ZonedDateTime;
          entity.nextSdrDateInformation[prop] = NextSDRDateTypes.LocalDate;
        }
      } else if (obj[prop] && typeof obj[prop] === "object") {
        UtilityFunctions.fixDateFields(obj[prop]);
      }
    }
  }
  static callFunctionForArray(funct, array) {
    array.forEach(element => {
      funct(element);
    });
  }
}
/**
 * Crea una funzione di tipo ExtractFromObject, navigando l'oggetto dato in pasto alla {@link ExtractFromObject}
 * @param dottedNavigationString una stringa del tipo dominio.descrizione
 *        che vuol dire estrai la proprietà descrizione della proprietà dominio dell'object
 *        dato come parametro della {@link ExtractFromObject}
 * @param notFoundValue il valore di default da dare se la proprietà non esiste, default {@literally undefinded}
 */
function extractValueDotAnnotation(dottedNavigationString, notFoundValue) {
  return object => {
    if (!notFoundValue) {
      notFoundValue = undefined;
    }
    const dotSplit = dottedNavigationString.split(".");
    const result = dotSplit.reduce((previousValue, currentValue) => {
      /*
                (previousValue[currentValue] || previousValue[currentValue] === 0)
                perchè senò lo zero viene visto come false
             */
      if (typeof previousValue === "object" && (previousValue[currentValue] || previousValue[currentValue] === false || previousValue[currentValue] === 0)) {
        return previousValue[currentValue];
      } else {
        return notFoundValue;
      }
    }, object);
    return result;
  };
}
/**
 * Funzione di utilità per ottenere l'estrazione dal {@param sourceObject} in base
 * al {@param extractFunct} che può essere una stringa è quindi interpretata attraverso {@link extractValueDotAnnotation}
 * oppure una funzione di tipo {@link ExtractFromObject}
 * @param extractFunct
 * @param sourceObject
 * @return l'estrazione dal sourceObjectin base al extractFunct
 */
function extractValueFromDotAnnotationOrFunction(extractFunct, sourceObject) {
  if (typeof extractFunct === "function") {
    return extractFunct(sourceObject);
  }
  if (typeof extractFunct === "string") {
    return extractValueDotAnnotation(extractFunct)(sourceObject);
  }
  return null;
}
class CustomURLEncoder {
  encodeKey(key) {
    return encodeURIComponent(key);
  }
  encodeValue(key) {
    return encodeURIComponent(key);
  }
  decodeKey(key) {
    return decodeURIComponent(key);
  }
  decodeValue(key) {
    return decodeURIComponent(key);
  }
}

/**
 * La classe astratta che deve essere implementata da tutti i services che vogliono utilizare NextSDR
 */
class NextSDREntityProvider {
  _RESPONSE_PAGE_FIELDS = "page";
  _RESPONSE_RESULTS_FIELDS = "_embedded";
  _PAGING_OFFSET_PARAMETER = "pagingOffset";
  _PAGING_LIMIT_PARAMETER = "pagingLimit";
  _PAGING_PAGE_PARAMETER = "page";
  _PAGING_SIZE_PARAMETER = "size";
  http;
  datepipe;
  entityConfiguration;
  restApiBaseUrl;
  constructor(http, datepipe, entityConfiguration, restApiBaseUrl) {
    this.http = http;
    this.datepipe = datepipe;
    this.entityConfiguration = entityConfiguration;
    // Se c'è la barra finale nell'url la togliamo
    if (restApiBaseUrl.endsWith("/")) {
      this.restApiBaseUrl = restApiBaseUrl.substr(0, restApiBaseUrl.length - 1);
    } else {
      this.restApiBaseUrl = restApiBaseUrl;
    }
  }
  /**
   * Metodo semicablato per querare e ottenere le entità
   * @param projection la projection che si vuole utilizzare per i risultati
   * @param initialFiltersAndSorts
   * @param lazyEventFiltersAndSorts
   * @param pagingConf vedi pagingConf di {@link this#getHttpCall}
   * @param noCount se true il backend non eseguirà il count, nella response totalElements non sarà attendibile
   */
  getData(projection, initialFiltersAndSorts, lazyEventFiltersAndSorts, pagingConf) {
    //  const queryString = this.buildQueryString(projection, initialFiltersAndSorts, lazyEventFiltersAndSorts);
    return this.getHttpCall(projection, initialFiltersAndSorts, lazyEventFiltersAndSorts, pagingConf).pipe(map(data => {
      //  console.log('DATA', data);
      if (data[this._RESPONSE_RESULTS_FIELDS]) {
        for (let prop in data._embedded) {
          UtilityFunctions.callFunctionForArray(UtilityFunctions.fixDateFields, data[this._RESPONSE_RESULTS_FIELDS][prop]);
        }
      }
      return data;
    }), map(value => {
      const result = {
        page: value[this._RESPONSE_PAGE_FIELDS],
        results: []
      };
      // se ci sono risultati nella response li setto
      if (value[this._RESPONSE_RESULTS_FIELDS] && value[this._RESPONSE_RESULTS_FIELDS][this.entityConfiguration.collectionResourceRel]) {
        result.results = value[this._RESPONSE_RESULTS_FIELDS][this.entityConfiguration.collectionResourceRel];
      }
      return result;
    })
    //   catchError(err => {
    //   console.log('ERROR', err);
    // }
    );
  }
  /**
   * Refactor del metodo di sopra, restitutisce degli httpParams invece che una stringa
   * @param httpParams
   * @param projection
   * @param initialFiltersAndSorts
   * @param lazyEventFiltersAndSorts
   * @param additionalData
   * @param pagingConf
   */
  buildQueryParams(httpParams, projection, initialFiltersAndSorts, lazyEventFiltersAndSorts, additionalData, pagingConf, refreshSavedEntity = false) {
    if (!httpParams) {
      httpParams = new HttpParams({
        encoder: new CustomURLEncoder()
      });
    }
    if (projection) {
      httpParams = httpParams.append("projection", projection);
    }
    const lazyLoadFilters = lazyEventFiltersAndSorts ? lazyEventFiltersAndSorts.filters : new Array();
    const lazyLoadSorts = lazyEventFiltersAndSorts ? lazyEventFiltersAndSorts.sorts : new Array();
    const lazyLoadAdditionalData = lazyEventFiltersAndSorts ? lazyEventFiltersAndSorts.additionalDatas : new Array();
    const initialFilters = initialFiltersAndSorts ? initialFiltersAndSorts.filters : new Array();
    const initialSorts = initialFiltersAndSorts ? initialFiltersAndSorts.sorts : new Array();
    const initialAdditionalData = initialFiltersAndSorts ? initialFiltersAndSorts.additionalDatas : new Array();
    const currentAdditionalData = additionalData ? additionalData : new Array();
    let totalFilters = new Array();
    let totalSorts = new Array();
    let totalAdditionalDatas = new Array();
    totalFilters = [...initialFilters, ...lazyLoadFilters];
    totalSorts = [...lazyLoadSorts, ...initialSorts];
    totalAdditionalDatas = [...lazyLoadAdditionalData, ...initialAdditionalData, ...currentAdditionalData];
    totalFilters.forEach(element => {
      // se il filterMatchMode è un filtro su un campo non_stringa e l'unico operatore accettato è l'uguale (=)
      if (element.filterMatchMode === "") {
        httpParams = httpParams.append(element.field, element.value);
      } else {
        httpParams = httpParams.append(element.field, "$" + element.filterMatchMode + "(" + element.value + ")");
      }
    });
    totalSorts.forEach(element => {
      httpParams = httpParams.append("sort", element.field + "," + element.orderMode);
    });
    if (totalAdditionalDatas && totalAdditionalDatas.length > 0) {
      let additionalDataString = "";
      totalAdditionalDatas.forEach(element => {
        additionalDataString += element.name + "=" + element.value + ",";
      });
      if (additionalDataString.length > 0) {
        // se c'è, tolgo la "," finale
        if (additionalDataString.substr(additionalDataString.length - 1, 1) === ",") {
          additionalDataString = additionalDataString.substr(0, additionalDataString.length - 1);
        }
        httpParams = httpParams.append("$additionalData", additionalDataString);
      }
    }
    // totalAdditionalDatas.forEach(element => {
    //     httpParams = httpParams.append('additionalData', element.name + '=' + element.value);
    // });
    if (pagingConf) {
      switch (pagingConf.mode) {
        case "PAGE":
        case "PAGE_NO_COUNT":
          httpParams = httpParams.append(this._PAGING_PAGE_PARAMETER, pagingConf.conf.page);
          httpParams = httpParams.append(this._PAGING_SIZE_PARAMETER, pagingConf.conf.size);
          break;
        case "LIMIT_OFFSET":
        case "LIMIT_OFFSET_NO_COUNT":
          httpParams = httpParams.append(this._PAGING_OFFSET_PARAMETER, pagingConf.conf.offset);
          httpParams = httpParams.append(this._PAGING_LIMIT_PARAMETER, pagingConf.conf.limit);
          break;
        case "NONE":
          httpParams = httpParams.append(this._PAGING_PAGE_PARAMETER, "0");
          httpParams = httpParams.append(this._PAGING_SIZE_PARAMETER, "9999999");
      }
      if (pagingConf.mode === "PAGE_NO_COUNT" || pagingConf.mode === "LIMIT_OFFSET_NO_COUNT") {
        httpParams = httpParams.append("noCount", true);
      }
    }
    if (refreshSavedEntity) {
      // Il framework prevede il default false, quindi lo passo solo se true
      httpParams = httpParams.append("refreshSavedEntity", true);
    }
    return httpParams;
  }
  /**
   * metodo di get per ottenere le entità
   * @param projection la projection che si vuole utilizzare per i risultati
   * @param initialFiltersAndSorts
   * @param lazyEventFiltersAndSorts
   * @param pagingConf per selezionare la modalità di paginazione
   * @param noCount se true il backend non eseguirà il count, nella response totalElements non sarà attendibile
   */
  getHttpCall(projection, initialFiltersAndSorts, lazyEventFiltersAndSorts, pagingConf) {
    const url = this.restApiBaseUrl + "/" + this.entityConfiguration.path;
    const httpParams = this.buildQueryParams(null, projection, initialFiltersAndSorts, lazyEventFiltersAndSorts, null, pagingConf);
    return this.http.get(url, {
      params: httpParams
    });
  }
  /**
   * Metodo per fare una get by id di un'entità
   * @param id l'id dell'entità che si vuole ottenere
   * @param projection la projection con cui si vuole avere l'entità
   */
  getByIdHttpCall(id, projection) {
    const url = this.restApiBaseUrl + "/" + this.entityConfiguration.path + "/" + id;
    const httpParams = this.buildQueryParams(null, projection, null, null, null, null);
    return this.http.get(url, {
      params: httpParams
    }).pipe(map(data => {
      //  console.log('DATA', data);
      if (data) {
        UtilityFunctions.fixDateFields(data);
      }
      return data;
    }));
  }
  /**
   * Fa una chiamata PATCH utile per aggiornare un entità passando solo i campi che si vogliono aggiornare
   * @param elementToUpdate l'entità con i campi che si vogliono aggiornare popolati
   * @param id l'id dell'entità da aggiornare
   * @param projection la projection da applicare all'entità modificata
   * @param additionalData dati opzionali per gli interceptor
   */
  patchHttpCall(elementToUpdate, id, projection, additionalData, refreshSavedEntity = false) {
    const elementToUpdateClean = UtilityFunctions.cleanObjForHttpCall(elementToUpdate, this.datepipe);
    this.removeKeyFromEntity(elementToUpdateClean);
    const url = this.restApiBaseUrl + "/" + this.entityConfiguration.path + "/" + id;
    const httpParams = this.buildQueryParams(null, projection, null, null, additionalData, null, refreshSavedEntity);
    const options = {
      //  headers: new HttpHeaders({'Content-Type': 'application/json'})
      headers: new HttpHeaders({
        "Content-Type": "application/merge-patch+json"
      }),
      params: httpParams
    };
    return this.http.patch(url, elementToUpdateClean, options).pipe(map(data => {
      //  console.log('DATA', data);
      if (data) {
        UtilityFunctions.fixDateFields(data);
      }
      return data;
    }));
  }
  /**
   * Fa una chiamata POST per la creazione di una nuova entità
   * @param entityToInsert l'entità da creare
   * @param projection la projection da applicare all'entità inserita
   * @param additionalData dati opzionali per gli interceptor
   */
  postHttpCall(entityToInsert, projection, additionalData, refreshSavedEntity = false) {
    // this.removeKeyFromEntity(entityToInsert);
    const elementToInsertClean = UtilityFunctions.cleanObjForHttpCall(entityToInsert, this.datepipe);
    const url = this.restApiBaseUrl + "/" + this.entityConfiguration.path;
    const httpParams = this.buildQueryParams(null, projection, null, null, additionalData, null, refreshSavedEntity);
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
      params: httpParams
    };
    return this.http.post(url, elementToInsertClean, options).pipe(map(data => {
      //  console.log('DATA', data);
      if (data) {
        UtilityFunctions.fixDateFields(data);
      }
      return data;
    }));
  }
  /**
   * Fa una chiamata delete, utili per cancellare un entità
   * @param id l'id dell'entita da cancellare
   * @param additionalData dati opzionali per gli interceptor
   */
  deleteHttpCall(id, additionalData) {
    const url = this.restApiBaseUrl + "/" + this.entityConfiguration.path + "/" + id;
    const httpParams = this.buildQueryParams(null, null, null, null, additionalData);
    // if (additionalData) {
    //     const queryString = this.buildQueryString(null, null, null, additionalData);
    //     if (queryString && queryString !== '') {
    //         url += '?' + queryString;
    //     }
    // }
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
      params: httpParams
    };
    return this.http.delete(url, options);
  }
  batchHttpCall(batchOperations) {
    batchOperations.forEach(batchOperation => batchOperation.entityBody = UtilityFunctions.cleanObjForHttpCall(batchOperation.entityBody, this.datepipe));
    const url = this.restApiBaseUrl + "/batch";
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };
    return this.http.post(url, batchOperations, options).pipe(map(data => {
      //BatchOperation[]
      //  console.log('DATA', data);
      if (data && data.length > 0) {
        data.forEach(op => {
          if (op.entityBody) {
            UtilityFunctions.fixDateFields(op.entityBody);
          }
        });
      }
      return data;
    }));
  }
  /**
   * Rimuove la chiave dall'entita
   * @param entity
   */
  removeKeyFromEntity(entity) {
    if (entity[this.entityConfiguration.keyName]) {
      delete entity[this.entityConfiguration.keyName];
    }
  }
  /**
   * Torna la chiave di un'entità
   * @param entity
   */
  getKeyOfEntity(entity) {
    return entity[this.entityConfiguration.keyName];
  }
}

/**
 * Modulo per le pagine dell'applicazione
 */
class NextSdrModule {
  /** @nocollapse */static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: NextSdrModule,
    deps: [],
    target: i0.ɵɵFactoryTarget.NgModule
  });
  /** @nocollapse */
  static ɵmod = i0.ɵɵngDeclareNgModule({
    minVersion: "14.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: NextSdrModule
  });
  /** @nocollapse */
  static ɵinj = i0.ɵɵngDeclareInjector({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: NextSdrModule
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: NextSdrModule,
  decorators: [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [],
      exports: [],
      providers: []
    }]
  }]
});

// definitions

/**
 * Generated bundle index. Do not edit.
 */

export { AdditionalDataDefinition, BatchOperation, BatchOperationTypes, FILTER_TYPES, FilterDefinition, FilterJsonDefinition, FiltersAndSorts, ForeignKey, NextSDRDateTypes, NextSDREntityProvider, NextSdrModule, SORT_MODES, SortDefinition, UtilityFunctions, extractValueDotAnnotation, extractValueFromDotAnnotationOrFunction };
